var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c(_vm.getComponent,{ref:"cptRef",tag:"component",on:{"changePage":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }